import axios from 'axios';
import qs from 'qs';
import { message } from 'antd';

const initServices = axios.create({
  baseURL: '/aaa',
  timeout: 6000
});

// // 请求拦截
initServices.interceptors.request.use(config => {

  // 要求form-data格式
  config.data = qs.stringify(config.data);
  console.log(config.data);
  return config;
}, error => {
  return Promise.reject(error);
})

// // 响应拦截
// ins.interceptors.response.use((response) => {
//   return response;
// }, (error) => {
//   return Promise.reject(error);
// });

const required = async config => {
  const { url = '', data = {}, method = 'get' } = config;
  const resetUrl = url + '?appid=10003&sign=7838933c355ada564af8c5e121abe360&timestamp=24234234';

  const requestIns = () => {
    switch (method.toLocaleUpperCase()) {
      case 'GET':
        return initServices.get(resetUrl, { params: data });
      case 'POST':
        return initServices.post(resetUrl, data);
      case 'PUT':
        return initServices.put(resetUrl, data);
      case 'DELETE':
        return initServices.delete(resetUrl, { data });
      default:
        return initServices.get(resetUrl, { params: data });
    }
  };

  try {
    const { data } = await requestIns();

    if (data.status !== 0) {
      throw Error(data.message);
    }

    return data.data || data;

  } catch (error) {
    message.error(error?.message || '');

    return false;
  }
};

export default required;
